export class BackgroundInfoJurisdiction {
  countryId: number;
  name: string;
  isoCode: string;
}
